<template>
  <div  class="app-wrapper">
    <page-header :title="title" :isFixed="headerFixed" ref="header"></page-header>
    <app-main :keywords="keywords"></app-main>
    <page-footer></page-footer>
    <login v-if="isLogin && isLogin != 'false'"></login>
    <register v-if="isRegister" :user="user"></register>
    <float-button v-if="isShowBtn"></float-button>
    <space-list v-if="showSpace"></space-list>
  </div>
</template>

<script>
import AppMain from '@/components/AppMain'
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import Login from '@/components/Login'
import Register from '@/components/Register'
import FloatButton from '@/components/FloatButton'
import SpaceList from '@/components/spaceList'

export default {
  name: 'App',
  components: { AppMain, PageHeader, PageFooter, Login, FloatButton, Register, SpaceList },
  computed: {
    isLogin () {
      return this.$store.state.isLogin;
    },
    title () {
      document.documentElement.scrollTop = 0
      return this.$route.meta.title
    }
  },
  data () {
    return {
      headerFixed: false,
      isShowBtn: false,
      isRegister: false,
      showSpace: false,
      keywords: '',
      user: {
        username:'',
        telephone: '',
        password: '',
        code: '',
      }
    }
  },
  watch: {
    keywords (val) {
     this.keywords = val
    }
  },
  mounted () {
    window.addEventListener("scroll",this.handleScroll)
  },
  methods: {
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 30) {
        this.headerFixed = true
      } else {
        this.headerFixed = false
      }
      if (scrollTop > 100) {
        this.isShowBtn = true
      } else {
        this.isShowBtn = false
      }
    },
  }
}
</script>

<style lang="scss">
  .app-wrapper {
    position: relative;
    height: 100vh;
    width: 100%;
    display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
    display: -moz-box; /* Firefox 17- */  
    display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */  
    display: -moz-flex; /* Firefox 18+ */  
    display: -ms-flexbox; /* IE 10 */  
    display: flex;
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
		min-height: auto;
  }
</style>
